import BaseCommand from "@/models/api/commands/BaseCommand";

export class GenerateRecordLocatorCommand extends BaseCommand {
  CommandName = "GenerateRecordLocator";
  Command = null;
  constructor(sessionId: string, operationId: string) {
    super(sessionId, operationId);
  }
}
